/* global React, HelpArticleBlocks */
// ============================================================
// PLUMME — Inline help-article body for Support > Articles
// Renders the blocks of a help article through the shared HelpArticleBlocks
// (help-article-blocks.jsx), which the drawer reader in help-articles.jsx also uses.
// It reuses the drawer's block-level `ha-*` classes (step, figure, tip, text), which
// are not scoped to the drawer; the page chrome around it is styled by
// src/styles/support-articles.css.
// ============================================================
(function (global) {
  function SupportArticleBody({ article }) {
    return <div className="sa-body"><HelpArticleBlocks blocks={article.blocks} variant="page" /></div>;
  }

  global.SupportArticleBody = SupportArticleBody;
})(typeof window !== 'undefined' ? window : globalThis);
